import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { Observable, of } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { SwiperContainer } from 'swiper/element';

export const ONGOING_LOGIN_SESSION_INFO = 'ONGOING_LOGIN_SESSION_INFO';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss', '../authentication.scss']
})
export class HomePage implements OnInit {
  viewModel$: Observable<any> = of({
    title: "Welcome",
    loginButtonText: "Already Registered",
    registerButtonText: "Register"
  });

  @ViewChild('slides') slides!: SwiperContainer;

  //theme: string;
  selectedCountryCode: string = "au";
  selectedLanguageName: string = "english";

  constructor(
    private docTitle: Title,
    private modalCtrl: ModalController,
    private analyticsService: AnalyticsService,
    private router: Router,
    private authService: AuthService,
  ) {
    this.viewModel$.subscribe(vm => this.docTitle.setTitle(vm.title));
    this.analyticsService.tagRoute('unauthenticated/home');
    // this.theme = this.brandProvider.get();
    // this.selectedCountryCode = this.global.getCountryCode();
    // this.selectedLanguageName = SUPPORTED_LOCALES_MAP[this.global.language];
  }

  ngOnInit() {
    try {
      this.checkForPendingCodeVerification();
    } catch(e) {
      console.error(e);
    }
  }

  async checkForPendingCodeVerification() {
    if (Capacitor.isNativePlatform()) {
      try {
        await this.authService.getCurrentUser();
      } catch (err: any) {
        const { phone, page, singleUseRegistrationPassword } = JSON.parse((await SecureStoragePlugin.get({ key: ONGOING_LOGIN_SESSION_INFO }).catch(() => {}))?.value ?? '{}') as { phone: string, page: string, singleUseRegistrationPassword?: string };
        if (phone && page) {
          if (page === 'verifysignup' && singleUseRegistrationPassword) {
            this.authService.singleUseRegistrationPassword = singleUseRegistrationPassword;
          }
          this.router.navigate(['unauthenticated', page], { queryParams: { phone } });
        }
      }
    }
  }

  goToRegister() {
    this.analyticsService.tagButtonPress('home_page', 'register');
    this.router.navigate(['unauthenticated', 'siteCodeEntry']);
  }

  goToLogin() {
    this.analyticsService.tagButtonPress('home_page', 'login');
    this.router.navigate(['unauthenticated', 'login']);
  }

  async nextSlide() {
    if (await this.slides.swiper.isEnd) {
      this.slides.swiper.slideTo(0);
    } else {
      this.slides.swiper.slideNext();
    }
  }

  async prevSlide() {
    if (await this.slides.swiper.isBeginning) {
      this.slides.swiper.slideTo(this.slides.swiper.slides.length - 1);
    } else {
      this.slides.swiper.slidePrev();
    }
  }

  // openLanguageSelectorModal() {
  //   const languageSelectorModal = this.modalCtrl.create(
  //     'LanguageSelectorModalPage',
  //   );
  //   languageSelectorModal.onDidDismiss(data => {
  //     this.selectedCountryCode = this.global.getCountryCode();
  //     this.selectedLanguageName = SUPPORTED_LOCALES_MAP[this.global.language];
  //     if (data && data.preferredLanguage) {
  //       this.storageService.set('loggedOutLanguage', data.preferredLanguage);
  //     }
  //   });
  //   languageSelectorModal.present();
  // }


  enableSliderControls() {
    return true;
  }
}
